import * as Sentry from '@sentry/react';

import config from 'config';
import Api from 'entities/api';

export const downloadFileFromApi = (url: string, fileName?: string) => {
  void fetch(`${config.apiUrl}/${url}`, {
    method: 'GET',
    headers: {
      Authorization: Api.defaultHeaders.Authorization,
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Could not download file');
      }
      return response.blob();
    })
    .then((blob) => {
      const objectUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = objectUrl;
      if (fileName) {
        a.download = fileName;
      }
      a.click();
      window.URL.revokeObjectURL(url);
    })
    .catch((error) => {
      Sentry.captureException(error, {
        level: 'warning',
        extra: {
          url,
          fileName,
        },
      });
      alert(error.message);
    });
};
